import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e48b7d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cmpLayer" }
const _hoisted_2 = { style: {"margin":"10px auto"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "cmpTitle" }, "We Care About Your Privacy", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"900","text-align":"center"} }, [
  /*#__PURE__*/_createTextVNode("This Site Does "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"900","text-decoration":"underline"} }, "NOT"),
  /*#__PURE__*/_createTextVNode(" use cookies or collect personal data for advertising.")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Thank you for visiting this site. We value your privacy. This site uses advertising to fund the content you are about to enjoy, but those advertisements are non-personalized in countries subject to the GDPR. We do not collect personal information for advertising purposes and we have instructed our advertising partners accordingly.", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "cmpButtonContainer",
  style: {"justify-content":"center"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"-14px"} }, "Continue to Site", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "cmpSVGButtonArrow",
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "2",
  viewBox: "0 0 500 500",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "__cmpIcon",
    d: "M479.3 250L246.5 482.7l-67.1-67L345 250 179.4 84.4l67.1-67.1L479.3 250z"
  })
], -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.logo_URL,
        style: {"max-width":"66vw","max-height":"72px"}
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    (_ctx.privacyPageURL)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
          _createTextVNode("If you have more questions, please refer to our "),
          _createElementVNode("a", {
            target: "_blank",
            href: _ctx.privacyPageURL
          }, "privacy policy", 8, _hoisted_8),
          _createTextVNode(" page.")
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_9, "You may find out more by visiting the privacy policy page from links on our site.")),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("a", {
        class: "cmpButtonLink acceptLink",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.continueToSiteClick && _ctx.continueToSiteClick(...args))),
        style: {"position":"relative"}
      }, _hoisted_13)
    ])
  ]))
}